import { cloneDeep } from 'lodash';
const SET_ACTIVE_FILTER_RESULT = 'SET_ACTIVE_FILTER_RESULT';

const initialState = {};

export default function reducer(state = cloneDeep(initialState), action) {
	switch (action.type) {
		case SET_ACTIVE_FILTER_RESULT:
			return action.payload;
		default:
			return state;
	}
}

export function setActiveFilterResult( filter ){
	return {
		type: SET_ACTIVE_FILTER_RESULT,
		payload: filter
	};
}



// WEBPACK FOOTER //
// ./src/modules/active_filter_result.js